import React from 'react';
import DocumentCard from '../DocumentCard';
import { useReveal } from '../../hooks/useReveal';
import { VOLUNTEER_DOCS } from '../../data/volunteer-docs';
import '../../styles/VolunteerDocs.css';

const TAPE_ROTATION: Array<'sage' | 'terracotta' | 'ochre'> = [
  'sage',
  'terracotta',
];

const VolunteerDocs: React.FC = () => {
  const { ref, revealed } = useReveal<HTMLElement>();

  return (
    <section
      ref={ref}
      className={`vol-docs psl-reveal${revealed ? ' is-in-view' : ''}`}
      id="voluntariado"
    >
      <div className="vol-docs__inner">
        <div className="vol-docs__head">
          <div className="vol-docs__chapter">Cap. IV · Voluntariado</div>
          <h2 className="vol-docs__title">
            Dar uma pata <em>— em pessoa.</em>
          </h2>
          <p className="vol-docs__lede">
            Há sempre trabalho no abrigo: limpar, alimentar, passear, socializar.
            Lê o regulamento, preenche a ficha de inscrição e fala connosco.
          </p>
        </div>

        <div className="vol-docs__grid">
          {VOLUNTEER_DOCS.map((doc, i) => (
            <figure className="vol-docs__item" key={doc.id}>
              <DocumentCard
                doc={doc}
                tapeColor={TAPE_ROTATION[i % TAPE_ROTATION.length]}
              />
              <figcaption className="vol-docs__caption">
                {doc.description}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VolunteerDocs;
